import { render } from "./Blogs_aggregation_page.vue?vue&type=template&id=68cbf999"
const script = {}

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__